/**
 @typedef PartialRefundPaymentResource
 @type {Object}
 @property {function(object, object, function, function)} store
 */

/**
 * @param $resource
 * @param apiRequestParams
 * @param {AppConfig} appConfig
 */
const PartialRefundPaymentResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'partialrefunds/:id',
        apiRequestParams.defaults(),
        {
            store: {
                method: 'POST',
                url: appConfig.apiBaseUrl + 'partialrefunds',
            },
        }
    );
};

module.exports = PartialRefundPaymentResource;
